
import { Link } from 'react-router-dom';

export default function IntrinsicExtrinsicPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-rose-50 via-pink-50 to-red-50">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-rose-600 via-pink-600 to-red-600 text-white py-20">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-4xl mx-auto">
            <Link to="/motivation" className="inline-flex items-center text-white/80 hover:text-white mb-6 transition-colors">
              <i className="ri-arrow-left-line mr-2"></i>
              動機付け一覧に戻る
            </Link>
            <div className="inline-flex items-center justify-center w-16 h-16 bg-white/20 backdrop-blur-sm rounded-xl mb-6">
              <i className="ri-heart-line text-4xl"></i>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4">内発的動機づけ／外発的動機づけ理論</h1>
            <p className="text-xl text-white/90">Intrinsic & Extrinsic Motivation</p>
          </div>
        </div>
      </section>

      {/* Core Message */}
      <section className="py-16">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <div className="bg-gradient-to-br from-rose-500 to-pink-500 rounded-2xl shadow-2xl p-8 md:p-12 text-white text-center">
              <h2 className="text-3xl font-bold mb-4">外発的（報酬・評価）は短期、内発的（意味・成長）は長期</h2>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto space-y-12">
            {/* 2つの動機づけ */}
            <div className="bg-white rounded-2xl shadow-lg p-8 border border-rose-100">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <div className="w-10 h-10 bg-gradient-to-br from-rose-500 to-pink-500 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-contrast-2-line text-xl text-white"></i>
                </div>
                2つの動機づけの違い
              </h2>
              <div className="grid md:grid-cols-2 gap-6">
                <div className="bg-gradient-to-br from-rose-50 to-pink-50 rounded-xl p-6 border border-rose-200">
                  <div className="w-12 h-12 bg-gradient-to-br from-rose-500 to-rose-600 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-gift-line text-2xl text-white"></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">外発的動機づけ</h3>
                  <p className="text-sm text-gray-600 mb-3">Extrinsic Motivation</p>
                  <ul className="text-gray-700 text-sm space-y-2">
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-rose-500 mr-1 mt-0.5"></i>
                      <span>報酬・給与・ボーナス</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-rose-500 mr-1 mt-0.5"></i>
                      <span>評価・昇進・表彰</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-rose-500 mr-1 mt-0.5"></i>
                      <span>罰則・ペナルティの回避</span>
                    </li>
                  </ul>
                  <div className="mt-4 p-3 bg-rose-100 rounded-lg">
                    <p className="text-sm text-rose-700 font-semibold">特徴：短期的な効果</p>
                  </div>
                </div>
                <div className="bg-gradient-to-br from-pink-50 to-red-50 rounded-xl p-6 border border-pink-200">
                  <div className="w-12 h-12 bg-gradient-to-br from-pink-500 to-pink-600 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-heart-3-line text-2xl text-white"></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">内発的動機づけ</h3>
                  <p className="text-sm text-gray-600 mb-3">Intrinsic Motivation</p>
                  <ul className="text-gray-700 text-sm space-y-2">
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-pink-500 mr-1 mt-0.5"></i>
                      <span>仕事の意味・やりがい</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-pink-500 mr-1 mt-0.5"></i>
                      <span>成長・学び・挑戦</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-pink-500 mr-1 mt-0.5"></i>
                      <span>興味・好奇心・楽しさ</span>
                    </li>
                  </ul>
                  <div className="mt-4 p-3 bg-pink-100 rounded-lg">
                    <p className="text-sm text-pink-700 font-semibold">特徴：長期的な効果</p>
                  </div>
                </div>
              </div>
            </div>

            {/* 薬局運営への活用 */}
            <div className="bg-white rounded-2xl shadow-lg p-8 border border-rose-100">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <div className="w-10 h-10 bg-gradient-to-br from-pink-500 to-rose-500 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-hospital-line text-xl text-white"></i>
                </div>
                薬局運営への活用
              </h2>
              <div className="space-y-6">
                <div className="bg-gradient-to-br from-rose-50 to-pink-50 rounded-xl p-6 border border-rose-200">
                  <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-bar-chart-box-line text-rose-600 mr-2"></i>
                    数値管理・インセンティブ設計
                  </h3>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    外発的動機づけ（インセンティブ）は短期的には効果がありますが、長期的には効果が薄れます。
                  </p>
                  <div className="bg-white rounded-lg p-4 border border-rose-100">
                    <p className="text-sm text-gray-700">
                      <strong className="text-rose-600">注意点：</strong>インセンティブに頼りすぎると、報酬がないと動かない状態になりやすい。また、報酬の基準が不明確だと不公平感を生む。
                    </p>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-pink-50 to-red-50 rounded-xl p-6 border border-pink-200">
                  <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-alert-line text-pink-600 mr-2"></i>
                    KPIの副作用チェック
                  </h3>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    KPIは外発的動機づけの一種です。設定の仕方によっては、内発的動機づけを損なう可能性があります。
                  </p>
                  <div className="grid md:grid-cols-2 gap-4">
                    <div className="bg-white rounded-lg p-4 border border-pink-100">
                      <h4 className="font-bold text-gray-900 mb-2 text-sm flex items-center">
                        <i className="ri-close-circle-line text-red-500 mr-2"></i>
                        副作用が出やすいKPI
                      </h4>
                      <ul className="text-xs text-gray-600 space-y-1">
                        <li>・数値だけを追う（質を無視）</li>
                        <li>・達成不可能な目標</li>
                        <li>・個人間競争を煽る</li>
                      </ul>
                    </div>
                    <div className="bg-white rounded-lg p-4 border border-pink-100">
                      <h4 className="font-bold text-gray-900 mb-2 text-sm flex items-center">
                        <i className="ri-checkbox-circle-line text-green-500 mr-2"></i>
                        内発的動機を守るKPI
                      </h4>
                      <ul className="text-xs text-gray-600 space-y-1">
                        <li>・プロセスも評価する</li>
                        <li>・チーム目標を設定</li>
                        <li>・成長指標を含める</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* バランスの取り方 */}
            <div className="bg-white rounded-2xl shadow-lg p-8 border border-rose-100">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <div className="w-10 h-10 bg-gradient-to-br from-rose-500 to-pink-500 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-scales-3-line text-xl text-white"></i>
                </div>
                バランスの取り方
              </h2>
              <div className="bg-gradient-to-br from-rose-50 to-pink-50 rounded-xl p-6 border border-rose-200">
                <p className="text-gray-700 leading-relaxed mb-4">
                  外発的動機づけと内発的動機づけは、どちらか一方ではなく、<strong className="text-rose-600">バランスが重要</strong>です。
                </p>
                <div className="space-y-4">
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-rose-500 rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                      <span className="text-white text-sm font-bold">1</span>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900">基盤としての外発的動機づけ</h4>
                      <p className="text-sm text-gray-600">適正な給与・評価制度は「不満を防ぐ」ために必要</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-pink-500 rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                      <span className="text-white text-sm font-bold">2</span>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900">成長のための内発的動機づけ</h4>
                      <p className="text-sm text-gray-600">意味・成長・挑戦は「やりがい」を生み出す</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-red-500 rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                      <span className="text-white text-sm font-bold">3</span>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900">外発的→内発的への移行</h4>
                      <p className="text-sm text-gray-600">最初は報酬で始めても、徐々に意味づけを加える</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 明日の一手 */}
            <div className="bg-gradient-to-br from-rose-600 via-pink-600 to-red-600 rounded-2xl shadow-2xl p-8 text-white">
              <h2 className="text-2xl font-bold mb-4 flex items-center">
                <i className="ri-calendar-check-line text-3xl mr-3"></i>
                明日の一手
              </h2>
              <p className="text-lg text-white/90 leading-relaxed mb-6">
                現在のKPIや評価制度が、内発的動機づけを損なっていないかチェックしてみましょう。
              </p>
              <div className="bg-white/20 backdrop-blur-sm rounded-xl p-6">
                <p className="text-white font-semibold mb-2">具体的なアクション：</p>
                <p className="text-white/90 leading-relaxed">
                  職員に「この仕事のどこにやりがいを感じますか？」「数値目標についてどう思いますか？」と問いかけ、内発的動機づけの状態を確認する。
                </p>
              </div>
            </div>

            {/* Navigation */}
            <div className="flex justify-between items-center pt-8 border-t border-gray-200">
              <Link to="/motivation/self-determination-theory" className="flex items-center text-rose-600 hover:text-rose-700 font-semibold transition-colors">
                <i className="ri-arrow-left-line mr-2"></i>
                自己決定理論
              </Link>
              <Link to="/motivation/goal-setting" className="flex items-center text-rose-600 hover:text-rose-700 font-semibold transition-colors">
                目標設定理論
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
